import fr from 'facet-rest';
import { useEffect } from 'react';
import useUser from 'Context/UserContext';

window.iterateSettings = {
  apiKey: process.env.ITERATE_API_KEY,
};

// With Iterate, the types sent here are important.  If you provide a key, the only way to change the type is to open a ticket
const formatUserInfo = userInfo => ({
  first_name: userInfo.attr('firstName'),
  last_name: userInfo.attr('lastName'),
  external_id: userInfo.id(),
  household_id: userInfo.attr('householdId') || '',
  ...userInfo.attributes(),
});

function IterateSurveyProvider({ children }) {
  const { userInformationCollection, userResource } = useUser();
  useEffect(() => {
    if (userResource) {
      if (!window.Iterate && userResource?.relationship(fr.relationships.iterateMaster.name)) {
        import('Integrations/iterate');
      }
    }
  }, [userInformationCollection]);

  // ----- Identify Iterate user -----
  useEffect(() => {
    if (userInformationCollection) {
      if (userResource?.relationship(fr.relationships.iterateMaster.name) && window.Iterate) {
        const [userInfoResource] = userInformationCollection;
        window.Iterate('identify', formatUserInfo(userInfoResource));
      }
    }
  }, [userInformationCollection, window.Iterate]);

  return children;
}

export { IterateSurveyProvider };
